import { cva, type VariantProps } from 'class-variance-authority'

export const badgeVariants = cva(
  'tw:inline-flex tw:items-center tw:gap-1 tw:rounded-md tw:font-medium',
  {
    variants: {
      variant: {
        'green': 'tw:bg-green-300 tw:text-green-800 tw:dark:bg-green-900 tw:dark:text-green-200',
        'blue': 'tw:bg-blue-300 tw:text-blue-800 tw:dark:bg-blue-900 tw:dark:text-blue-200',
        'yellow': 'tw:bg-yellow-300 tw:text-yellow-800 tw:dark:bg-yellow-900 tw:dark:text-yellow-200',
        'red': 'tw:bg-red-300 tw:text-red-800 tw:dark:bg-red-900 tw:dark:text-red-200',
        'zinc': 'tw:bg-zinc-300 tw:text-zinc-800 tw:dark:bg-zinc-900 tw:dark:text-zinc-200',
        'zinc-light': 'tw:bg-zinc-100 tw:text-zinc-800 tw:dark:bg-zinc-700 tw:dark:text-zinc-200',
        'enabled': 'tw:bg-zinc-100 tw:text-green-600 tw:dark:bg-green-900 tw:dark:text-green-200',
        'disabled': 'tw:bg-zinc-100 tw:text-zinc-400 tw:dark:bg-gray-700 tw:dark:text-gray-400',
        // An emphasis ramp rather than a verdict: for settings, where a stronger
        // value is not a worse one and an alarm colour would only mislead.
        'muted': 'tw:bg-transparent tw:text-zinc-400 tw:dark:text-zinc-500',
        'neutral': 'tw:bg-zinc-100 tw:text-zinc-700 tw:dark:bg-zinc-700 tw:dark:text-zinc-100',
        'accent': 'tw:bg-zinc-800 tw:text-zinc-50 tw:dark:bg-zinc-100 tw:dark:text-zinc-900',
      },
      size: {
        // Trailing inline content, where md would make the badge taller than
        // the line it belongs to.
        sm: 'tw:px-1.5 tw:py-0 tw:text-xs',
        // Standing on its own, in a table cell or at the end of a line.
        md: 'tw:px-2 tw:py-1 tw:text-xs',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
